<template>
  <div class="bulb page-wrapper">
    <div class="container">
      <div class="row">
        <div style="overflow:hidden">
          <el-row class="section1" :gutter="120">
            <el-col :span="12" :xs="{ span: 24 }">
              <img src="../../assets/bulb_ig.png" alt="">
            </el-col>
            <el-col :span="12" :xs="{ span: 24 }">
              <h3>球泡灯</h3>
              <p>千万色彩调节  |  App控制  |  远程控制  |  定时开关</p>
              <div class="feature">
                <div>
                  <div>
                    <img src="../../assets/bulb_ln.png" alt="">
                    <label for="">冷暖调节</label>
                  </div>
                  <div>
                    <img src="../../assets/bulb_cs.png" alt="">
                    <label for="">彩光调节</label>
                  </div>
                  <div>
                    <img src="../../assets/bulb_ld.png" alt="">
                    <label for="">亮度调节</label>
                  </div>
                  <div>
                    <img src="../../assets/bulb_dz.png" alt="">
                    <label for="">多种控制</label>
                  </div>
                </div>
                <div>
                  <div>
                    <img src="../../assets/bulb_zn.png" alt="">
                    <label for="">智能联动</label>
                  </div>
                  <div>
                    <img src="../../assets/bulb_ds.png" alt="">
                    <label for="">定时控制</label>
                  </div>
                  <div>
                    <img src="../../assets/bulb_djs.png" alt="">
                    <label for="">倒数计时</label>
                  </div>
                  <div>
                    <img src="../../assets/bulb_qj.png" alt="">
                    <label for="">情景切换</label>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="split"></div>
    <div class="container">
      <div class="row">
        <img class="section2" src="../../assets/bulb_xq.png" alt="">
      </div>
    </div>
  </div>  
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  margin: 40px 0 60px;
  .el-col {
    position: relative;
    img {
      width: 100%;
    }
  }
  .el-col:last-child {
    h3 {
      font-size: 28px;
      font-weight: normal;
      margin-bottom: 16px;
    }
  }
  .feature {
    margin-top: 60px;
    & > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 36px;
      label {
        display: block;
        margin-top: 16px;
      }
    }
  }
}
.section2 {
  margin: 40px 0;
  max-width: 100%;
}
.section1 .feature > div > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100px;
  justify-content: space-between;
  img {
    width: auto;
  }
}

.split {
  height: var(--margin-small);
  background-color: #ECECEC;
}
</style>